export default __webpack_public_path__ + "static/media/Ambient, Orange.c175756b.png";